module.exports = __webpack_public_path__ + "static/media/66.5b364609.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/66.png
// module id = 640
// module chunks = 0